module.exports = __webpack_public_path__ + "img/gqfx.f24f44aa.png";